// extracted by mini-css-extract-plugin
export default {"card":"SignUp_Login_card__FW7qH","form-control":"SignUp_Login_form-control__Fkp-H","btn":"SignUp_Login_btn__m2tjE","link":"SignUp_Login_link__wfFxK"};